function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import Stickyard from 'stickyard';
import { useLocale } from '@adsk/alloy-react-helpers';
import { defaultGroupHeaderRenderer, defaultSelectBoxRenderer, defaultMenuRenderer, defaultItemRenderer, defaultLabelRenderer } from '../layout/defaultRenderers';
import SelectBox from '../SelectBox';
export var GROUP_TYPE = '__selectbox_group_header__';

function flattenOptions(options, groupOptionsKey, valueKey) {
  var groupMap = {};
  var newOptions = options.reduce(function (flattenedOptions, group) {
    var items = group[groupOptionsKey];

    if (Array.isArray(items)) {
      if (items.length > 0) {
        items.forEach(function (item) {
          groupMap[item[valueKey]] = group;
        });
        flattenedOptions = flattenedOptions.concat(items);
      }
    } else {
      flattenedOptions.push(group);
    }

    return flattenedOptions;
  }, []);
  return [newOptions, groupMap];
}
/**
 * GroupedSelectBox, extends [SelectBox](selectbox) to add grouped support
 */


var GroupedSelectBox = /*#__PURE__*/function (_React$Component) {
  _inherits(GroupedSelectBox, _React$Component);

  var _super = _createSuper(GroupedSelectBox);

  function GroupedSelectBox(props) {
    var _this;

    _classCallCheck(this, GroupedSelectBox);

    _this = _super.call(this, props);
    _this.getGroupLabel = _this.getGroupLabel.bind(_assertThisInitialized(_this));
    _this.getOptionLabel = _this.getOptionLabel.bind(_assertThisInitialized(_this));
    _this.getOptionSubtext = _this.getOptionSubtext.bind(_assertThisInitialized(_this));
    _this.menuRenderer = _this.menuRenderer.bind(_assertThisInitialized(_this));
    _this.itemRenderer = _this.itemRenderer.bind(_assertThisInitialized(_this));
    _this.optionRenderer = _this.optionRenderer.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    var _this$props = _this.props,
        options = _this$props.options,
        groupOptionsKey = _this$props.groupOptionsKey,
        valueKey = _this$props.valueKey;

    var _flattenOptions = flattenOptions(options, groupOptionsKey, valueKey);

    var _flattenOptions2 = _slicedToArray(_flattenOptions, 2);

    _this.options = _flattenOptions2[0];
    _this.groupMap = _flattenOptions2[1];
    _this.selectedKeys = [];
    return _this;
  }

  _createClass(GroupedSelectBox, [{
    key: "getGroupLabel",
    value: function getGroupLabel(item) {
      var _this$props2 = this.props,
          groupLabelKey = _this$props2.groupLabelKey,
          groupLabelGetter = _this$props2.groupLabelGetter;
      return groupLabelGetter ? groupLabelGetter(item) : item[groupLabelKey] || '';
    }
  }, {
    key: "getOptionLabel",
    value: function getOptionLabel(item) {
      var _this$props3 = this.props,
          labelGetter = _this$props3.labelGetter,
          labelKey = _this$props3.labelKey;
      return labelGetter ? labelGetter(item) : item[labelKey] || '';
    }
  }, {
    key: "getOptionSubtext",
    value: function getOptionSubtext(item) {
      var _this$props4 = this.props,
          subtextGetter = _this$props4.subtextGetter,
          subtextKey = _this$props4.subtextKey;
      return subtextGetter ? subtextGetter(item) : item[subtextKey] || '';
    }
  }, {
    key: "menuRenderer",
    value: function menuRenderer(args) {
      var _this2 = this;

      var _this$props5 = this.props,
          multiple = _this$props5.multiple,
          valueKey = _this$props5.valueKey,
          stickyHeader = _this$props5.stickyHeader,
          _this$props5$maxMenuH = _this$props5.maxMenuHeight,
          maxMenuHeight = _this$props5$maxMenuH === void 0 ? 300 : _this$props5$maxMenuH,
          _this$props5$menuRend = _this$props5.menuRenderer,
          menuRenderer = _this$props5$menuRend === void 0 ? defaultMenuRenderer : _this$props5$menuRend;

      if (!this.selectedKeys.length && multiple) {
        var selectedValue = args.selectedValue;
        this.selectedKeys = Array.isArray(selectedValue) ? selectedValue.map(function (x) {
          return x[valueKey];
        }) : [];
      }

      this.lastGroup = undefined;
      this.registerSticky = undefined;
      if (!stickyHeader) return menuRenderer(args);
      return /*#__PURE__*/React.createElement(Stickyard, null, function (_ref) {
        var registerContainer = _ref.registerContainer,
            registerSticky = _ref.registerSticky;
        _this2.registerSticky = registerSticky;
        return /*#__PURE__*/React.createElement("div", {
          ref: registerContainer,
          style: {
            maxHeight: maxMenuHeight
          }
        }, menuRenderer(args));
      });
    }
  }, {
    key: "itemRenderer",
    value: function itemRenderer(args) {
      var _this$props6 = this.props,
          valueKey = _this$props6.valueKey,
          showValueAsTags = _this$props6.showValueAsTags,
          _this$props6$itemRend = _this$props6.itemRenderer,
          itemRenderer = _this$props6$itemRend === void 0 ? defaultItemRenderer : _this$props6$itemRend,
          _this$props6$groupHea = _this$props6.groupHeaderRenderer,
          groupHeaderRenderer = _this$props6$groupHea === void 0 ? defaultGroupHeaderRenderer : _this$props6$groupHea;
      var value = args.item[valueKey];
      var group = this.groupMap[value];

      if ((showValueAsTags || this.selectedKeys.indexOf(value) === -1) && group && group !== this.lastGroup) {
        this.lastGroup = group;
        var headerProps = {
          ref: this.registerSticky,
          key: this.getGroupLabel(group)
        };
        var header = groupHeaderRenderer(group, headerProps, this.props);
        return [header, itemRenderer(args)];
      }

      return itemRenderer(args);
    }
  }, {
    key: "optionRenderer",
    value: function optionRenderer(option, selected, selectProps) {
      var _this$props7 = this.props,
          valueKey = _this$props7.valueKey,
          showValueAsTags = _this$props7.showValueAsTags,
          optionRenderer = _this$props7.optionRenderer;
      var value = option[valueKey];
      if (optionRenderer) return optionRenderer(option, selected, selectProps);
      var label = this.getOptionLabel(option);
      var subtext = this.getOptionSubtext(option); // if selected, append group title to the option label

      if (!showValueAsTags && this.selectedKeys.indexOf(value) >= 0) {
        var group = this.groupMap[value];

        if (group) {
          var groupLabel = this.getGroupLabel(group);
          label = "".concat(label, " (").concat(groupLabel, ")");
        }
      }

      return defaultLabelRenderer(label, subtext);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.selectedKeys = [];
      this.props.onClose && this.props.onClose();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.options !== this.props.options) {
        var options = nextProps.options,
            groupOptionsKey = nextProps.groupOptionsKey,
            valueKey = nextProps.valueKey;

        var _flattenOptions3 = flattenOptions(options, groupOptionsKey, valueKey);

        var _flattenOptions4 = _slicedToArray(_flattenOptions3, 2);

        this.options = _flattenOptions4[0];
        this.groupMap = _flattenOptions4[1];
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          children = _this$props8.children,
          multiple = _this$props8.multiple,
          optionRenderer = _this$props8.optionRenderer;
      return children(_objectSpread(_objectSpread({}, this.props), {}, {
        options: this.options,
        menuRenderer: this.menuRenderer,
        itemRenderer: this.itemRenderer,
        optionRenderer: multiple ? this.optionRenderer : optionRenderer,
        onClose: this.handleClose
      }));
    }
  }]);

  return GroupedSelectBox;
}(React.Component);

GroupedSelectBox.GROUP_TYPE = GROUP_TYPE;
GroupedSelectBox.defaultProps = _objectSpread(_objectSpread({}, SelectBox.defaultProps), {}, {
  children: defaultSelectBoxRenderer,
  valueKey: 'value',
  labelKey: 'label',
  subtextKey: 'subtext',
  groupLabelKey: 'label',
  groupOptionsKey: 'options',
  stickyHeader: true
});
GroupedSelectBox.propTypes = _objectSpread(_objectSpread({}, SelectBox.propTypes), {}, {
  /**
   * render function
   */
  children: PropTypes.func.isRequired,

  /**
   * The key of the group label
   */
  groupLabelKey: PropTypes.string,

  /**
   * `(group) => string`, group label formatter
   */
  groupLabelGetter: PropTypes.func,

  /**
   * The key of the group options
   */
  groupOptionsKey: PropTypes.string,

  /**
   * `(group, headerProps, selectProps) => node`, custom group header renderer
   */
  groupHeaderRenderer: PropTypes.func,

  /**
   * whether the header is sticky
   */
  stickyHeader: PropTypes.bool
});

var WrapperGroupedSelectBox = function WrapperGroupedSelectBox(props) {
  var _useLocale = useLocale(function (_ref2) {
    var locale = _ref2.locale;
    return require("../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(GroupedSelectBox, _extends({}, props, {
    T: T
  }));
};

export default WrapperGroupedSelectBox;
//# sourceMappingURL=GroupedSelectBox.js.map